import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Header } from 'semantic-ui-react'
import { NoOrdenRender } from '../../Controles/NoOrdenRender'
import { OrdenRender } from '../../Controles/OrdenRender'
import { SetOrdenesActivas } from '../../Reducers/InicioReducer'
import { MostrarPopup } from '../../Reducers/PopupReducer'
import { ColocarOrdenAsync, ObtenerOrderIdAsync, ObtenerOrderTradesAsync, OrdenesActivasTodasAsync, OrdenMonitorAsync, OrdenMonitorCancelarAsync, OrdenMonitorObtenerAsync } from '../../Servicios/ServiciosPublicos'
import { MonitorOrdenesPopup } from './MonitorOrdenesPopup'
import Swal from 'sweetalert2'
import numeral from 'numeral'

export const MonitorOrdenes = () => {
    //#region hooks
    const dispatch = useDispatch()
    const inicio = useSelector(state => state.inicio)
    const { MonitorOrdenes } = inicio;
    const _internalStateRef = useRef();
    //#endregion
    //#region internalState
    const [internalState, setInternalState] = useState({
        OrdenesActivas: [],
        ListaMonitor: [],
    })
    _internalStateRef.current = internalState;

    //#endregion    
    //#region useeffects
    useEffect(() => {
        Load();

        const _objInt = setInterval(() => {
            MetodoInterval();
        }, 30000);

        return () => {
            _internalStateRef.current = null;

            if (_objInt) {
                console.log("mato al interval")
                clearInterval(_objInt);
            }
        }
    }, [])
    //#endregion
    //#region Metodos
    const Load = async () => { MetodoInterval(); }
    const MetodoInterval = async () => {
        await ObtenerOrdenesActivas();
        await OrdenMonitorObtener();
    }
    const ObtenerOrdenesActivas = async () => {
        let _ordenes = await OrdenesActivasTodasAsync();
        console.log(_ordenes)
        setInternalState((state) => ({ ...state, OrdenesActivas: _ordenes.Detalle }));
    }
    const OrdenMonitorObtener = async () => {
        let ListaMonitor = await OrdenMonitorObtenerAsync();
        console.log("ListaMonitor... ", ListaMonitor)
        setInternalState((state) => ({ ...state, ListaMonitor }));
    }
    const OnClickOrden = async (item) => {
        dispatch(MostrarPopup({
            Titulo: `Monitorear Orden`,
            Content: <MonitorOrdenesPopup />,
            TieneBotonCerrar: true,
            Cerrar: async (r) => {
                if (r) {
                    console.log(r)
                    let _list = [internalState.ListaMonitor];
                    if (_list.filter(f => f.id === item.id).length === 0) {
                        let _ordenMonitor = {
                            oid: item.id,
                            status: "open",
                            ...r,
                        }
                        await OrdenMonitorAsync(_ordenMonitor);
                        await MetodoInterval();
                    }

                }
            }
        }))
    }
    const OnClickOrdenMonitor = async (item) => {
        const result = await Swal.fire({
            title: 'Monitor de Ordenes',
            text: 'Desea Cancelar el monitoreo de la orden?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        });
        if (result.value) {
            let _sr = await OrdenMonitorCancelarAsync(item.id);
            await MetodoInterval();
        }
    }
    const RevisarOrdenes = async () => {
        if (_internalStateRef.current) {
            if (_internalStateRef.current.ListaMonitor) {
                if (_internalStateRef.current.ListaMonitor.length > 0) {
                    console.log("RevisarOrdenes...", _internalStateRef.current.ListaMonitor);
                    let _lista = [..._internalStateRef.current.ListaMonitor];
                    let _nl = [];
                    let _cambioLista = false;

                    for (let i = 0; i < _lista.length; i++) {
                        const _orden = _lista[i];
                        let _result = await ObtenerOrderIdAsync(_orden.id);
                        console.log(_result);
                        if (_result.success) {
                            if (_result.payload.Status === "closed" || _result.payload.Status === 'completed') {
                                //#region Esta Cerrada la orden
                                let _pc = +_orden.PorCompra, _pv = +_orden.PorVenta;
                                let _esVenta = _orden.Item.Tipo === "venta";
                                let _porRender = (_esVenta ? +_pc : +_pv);
                                _porRender = numeral(_porRender).format("0.00");

                                if (+_pc > 0) {
                                    _pc = 1 - (_pc / 100);
                                } else { _pc = 0.95; }
                                if (+_pv > 0) {
                                    _pv = 1 + (_pv / 100);
                                } else { _pv = 1.05; }

                                let _ni = +_orden.Item.Precio * (_esVenta ? +_pc : +_pv);
                                let _amount = +numeral(+_orden.Item.Total / +_ni).format("0.00000000");

                                let _newOrder = {
                                    book: _result.payload.Item.book,
                                    side: _result.payload.Item.side === "buy" ? "sell" : "buy",
                                    type: "limit",
                                    price: +numeral(_ni).format("0.0000"),
                                    major: +_amount,
                                };
                                let r = await ColocarOrdenAsync(_newOrder);
                                if (r.success) {
                                    _cambioLista = true;
                                    let _nuevaOrden = await ObtenerOrderIdAsync(r.payload.oid);
                                    let _obj = {
                                        Item: {
                                            Item: _nuevaOrden.payload.Item,
                                            Cantidad: +_amount,
                                            Precio: +_ni,
                                            Tipo: _nuevaOrden.payload.Item.side === "buy" ? "compra" : "venta",
                                            id: r.payload.oid,
                                            Total: +_orden.Item.Total
                                        },
                                        PorCompra: _orden.PorCompra,
                                        PorVenta: _orden.PorVenta,
                                        id: r.payload.oid
                                    }
                                    _nl = [..._nl, _obj];
                                } else {
                                    console.log(r);
                                    _nl = [..._nl, _orden];
                                }
                                //#endregion
                            } else { _nl = [..._nl, _orden]; }
                        } else if (_result.error) {
                            console.log(_result.error.message);
                            let _result = await Swal.fire({
                                title: ``,
                                html: _result.error.message,
                                icon: 'error',
                                confirmButtonText: 'Aceptar',
                            });
                        } else {
                            _nl = [..._nl, _orden];
                        }
                    }
                    if (!_cambioLista) {
                        setTimeout(() => { RevisarOrdenes(); }, 5000);
                    } else {
                        dispatch(SetOrdenesActivas(_nl));
                    }
                }
            }
        }
    }
    //#endregion
    return (
        <div>
            <Header><div className="ordenes-header-titulo">Ordenes Activas</div></Header>
            {internalState.OrdenesActivas.map((item, i) => (<OrdenRender Item={item} ObtenerOrdenesActivas={ObtenerOrdenesActivas} MostrarMoneda OnClick={OnClickOrden} />))}
            {internalState.OrdenesActivas.length === 0 && (<NoOrdenRender />)}
            {
                internalState.ListaMonitor.length > 0 && (<>
                    <Header><div className="ordenes-header-titulo">Monitor de Ordenes Activas</div></Header>
                    {internalState.ListaMonitor.map((item, i) => (<OrdenRender
                        Item={item.Item}
                        PorVenta={item.PorVenta}
                        PorCompra={item.PorCompra}
                        ObtenerOrdenesActivas={ObtenerOrdenesActivas}
                        MostrarMoneda OnClick={OnClickOrdenMonitor}
                    />))}
                </>)
            }
        </div>
    )
}